import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import _compact from 'lodash/compact';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';

import { getFirstAndLastName, getRubles } from 'utils/helpers';
import MGrid from 'components/MaterialUI/MGrid';
import MPaper from 'components/MaterialUI/MPaper';
import FormInputDisplay from 'components/FormElements/FormInputDisplay';

const useStyles = makeStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.palette.grey5.main}`,
  },
  paperSelected: {
    zIndex: 2,
    position: 'relative',
    backgroundColor: theme.palette.blue5.main,
    border: `1px solid ${theme.palette.info.main}`,
  },
  index: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey5.main,
    borderRadius: '50%',
    color: theme.palette.white.main,
  },
  indexOpen: {
    backgroundColor: theme.palette.info.main,
  },
}));

const HotelCard = (props) => {
  const { index, orderItem } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const hotel = orderItem?.['reservation']?.['hotel'];
  const rate = orderItem?.['reservation']?.['rate'];
  const travellers = orderItem?.['travellers'];
  const actualPrice = orderItem?.reservation?.actual_sell_price?.provider_total?.gross?.cents || 0;
  const originalPrice = orderItem?.reservation?.initial_sell_price?.provider_total?.gross?.cents || 0;
  const supplierReservation = orderItem?.['reservation']?.['supplier_reservation_id'];

  const reservation = supplierReservation?.map((item) => _compact(item).join(', '));

  const getGuests = () => {
    return travellers.length ? travellers.map((traveller) => getFirstAndLastName(traveller)).join(', ') : '-';
  };

  const amenities = rate && rate?.['amenities']?.map((item) => t(`Hotels.${item}`)).join(', ');

  return (
    <MGrid size={12} spacing={3}>
      <Grid item children={<div className={clsx(classes.index, { [classes.indexOpen]: open })} children={index} />} />
      <Grid item xs>
        <MPaper
          clean
          withGrid
          gridProps={{ spacing: 4 }}
          className={clsx(classes.paper, { [classes.paperSelected]: open })}
        >
          <MGrid size={12} columnSpacing={3}>
            <FormInputDisplay size={2} label={t('Orders.Booking')} value={reservation} />
            <FormInputDisplay label={t('Orders.Guest')} value={getGuests()} />
          </MGrid>

          <MGrid columnSpacing={3} size={12}>
            <FormInputDisplay size={2} label={t('Orders.Address')} value={hotel?.address} isBold />
            <FormInputDisplay size={2} label={t('Orders.Hotel')} value={hotel?.name} isBold />
            <FormInputDisplay size={2} label={t('Orders.Stars')} value={`${hotel?.['star_rating']}*`} isBold />
            <FormInputDisplay size={2} label={t('Orders.RoomCategory')} value={rate['room_data_trans']['main_name']} />
            <FormInputDisplay size={2} label={t('Orders.Amenities')} value={amenities} />
            <FormInputDisplay size={2} label={t('Orders.Meal')} value={rate?.meal && t(`Hotels.${rate?.meal}`)} />
          </MGrid>

          <MGrid size={12} columnSpacing={3}>
            <Grid item xs={2} />
            <FormInputDisplay size={2} label={t('Orders.OriginalPrice')} value={getRubles(originalPrice)} isBold />
            <FormInputDisplay size={2} label={t('Orders.ActualPrice')} value={getRubles(actualPrice)} isBold />
            <FormInputDisplay size={2} label={t('Orders.BackSum')} value="-" isBold />
          </MGrid>
        </MPaper>
      </Grid>
    </MGrid>
  );
};

HotelCard.propTypes = {
  orderId: PropTypes.any,
  index: PropTypes.number,
  orderItem: PropTypes.object,
};

HotelCard.defaultProps = {
  orderItem: {},
};

export default HotelCard;
